'use client'

import { motion } from 'framer-motion'

interface HeroSectionProps {
  title: string
  sub_title: string
}

export function HeroSection({ title, sub_title }: HeroSectionProps) {
  return (
    <section className="relative py-4 sm:py-2" id="hero">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            {/* <span className="text-base font-semibold tracking-wider uppercase text-gradient-glowing !text-[16px] !pt-[13px] !pb-[13px]">
              Real Users, Real Results
            </span> */}
            <h1 className="text-4xl md:text-5xl lg:text-[82px] lg:leading-tight font-bold tracking-tight text-white mt-0 whitespace-pre-line">
              {title}
            </h1>
            <p className="mt-6 text-lg md:text-xl text-gray-300 max-w-3xl mx-auto text-[18px] whitespace-pre-line">
              {sub_title}
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  )
}
